import { useState, useEffect } from "react";
import { X, Check } from "@phosphor-icons/react";

const SortModal = ({
  isVisible,
  onClose,
  onSave,
  onCancel,
  currentSortType = "CREATED_AT_DESC",
  productFilterData,
}) => {
  const [selectedSortType, setSelectedSortType] = useState(currentSortType);
  const [modalVisible, setModalVisible] = useState(false);

  useEffect(() => {
    if (isVisible) {
      setSelectedSortType(currentSortType);
      setTimeout(() => setModalVisible(true), 10);
    } else {
      setModalVisible(false);
    }
  }, [isVisible, currentSortType]);

  const sortOptions = [
    {
      value: "CREATED_AT_DESC",
      label: "En Yeniler",
      available: true,
    },
    {
      value: "CREATED_AT_ASC",
      label: "En Eskiler",
      available: true,
    },
    {
      value: "PRICE_ASC",
      label: "Fiyat (Düşükten Yükseğe)",
      available: true,
    },
    {
      value: "PRICE_DESC",
      label: "Fiyat (Yüksekten Düşüğe)",
      available: true,
    },
    {
      value: "NAME",
      label: "İsme Göre (A-Z)",
      available: !productFilterData?.disabledSortTypes?.includes("NAME"),
    },
    {
      value: "SALE_COUNT",
      label: "En Çok Satanlar",
      available: !productFilterData?.disabledSortTypes?.includes("SALE_COUNT"),
    },
    {
      value: "REVIEW_COUNT",
      label: "En Çok Yorumlananlar",
      available:
        !productFilterData?.disabledSortTypes?.includes("REVIEW_COUNT"),
    },
    {
      value: "AVERAGE_RATING",
      label: "En Yüksek Puanlılar",
      available:
        !productFilterData?.disabledSortTypes?.includes("AVERAGE_RATING"),
    },
  ];

  const availableSortOptions = sortOptions.filter((option) => option.available);

  const handleSortSelect = (sortType) => {
    setSelectedSortType(sortType);
  };

  const handleSave = () => {
    onSave(selectedSortType);
    onClose();
  };

  const handleCancel = () => {
    onCancel();
    onClose();
  };

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 z-[400] bg-black bg-opacity-50">
      <div
        className={`fixed bottom-0 left-0 right-0 bg-white rounded-t-2xl max-h-[70vh] flex flex-col transition-transform duration-300 ${
          modalVisible ? "translate-y-0" : "translate-y-full"
        }`}
      >
        {/* Header */}
        <div className="flex items-center justify-between p-4 border-b border-gray-200">
          <div className="w-6"></div> {/* Spacer */}
          <h2 className="text-lg font-semibold">Sırala</h2>
          <button
            onClick={onClose}
            className="p-1 hover:bg-gray-100 rounded-full transition-colors"
            aria-label="Close sort"
          >
            <X size={20} />
          </button>
        </div>

        {/* Sort Options */}
        <div className="flex-1 overflow-y-auto p-4">
          <div className="space-y-2">
            {availableSortOptions.map((option) => {
              const isSelected = selectedSortType === option.value;

              return (
                <button
                  key={option.value}
                  onClick={() => handleSortSelect(option.value)}
                  className={`w-full text-left px-4 py-4 rounded-lg border transition-all ${
                    isSelected
                      ? "bg-black text-white border-black"
                      : "bg-white border-gray-200 hover:border-gray-300"
                  }`}
                >
                  <div className="flex items-center justify-between">
                    <span className="font-medium">{option.label}</span>
                    {isSelected && <Check size={18} weight="bold" />}
                  </div>
                </button>
              );
            })}
          </div>
        </div>

        {/* Footer Buttons */}
        <div className="p-4 border-t border-gray-200 bg-white">
          <div className="flex gap-3">
            <button
              onClick={handleCancel}
              className="flex-1 py-3 px-4 border border-gray-300 rounded-lg text-gray-700 font-medium hover:bg-gray-50 transition-colors"
            >
              Cancel
            </button>
            <button
              onClick={handleSave}
              className="flex-1 py-3 px-4 bg-black text-white rounded-lg font-medium hover:bg-gray-800 transition-colors"
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SortModal;
